import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'empty'
})
export class ArrayEmptyPipe implements PipeTransform {
  transform(entries: Array<any>): boolean {
    return entries.length === 0;
  }
}
